'use client';

import type { ProductDetailData } from '@eliadmin/core/src/api/products/types/product-types';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { Paragraph } from '../../ui/paragraph';

export function ProductAdditionalInfo({ product }: { product: ProductDetailData }) {
  const { t } = useTranslations();

  return (
    <div className="flex w-full flex-wrap items-start justify-start gap-x-4 gap-y-2">
      {product.categories && product.categories.length > 0 && (
        <div className="flex w-fit flex-nowrap items-center justify-start gap-2">
          <Paragraph size="sm" className="whitespace-nowrap">
            {t('text230')}
          </Paragraph>
          <p className="flex h-[30px] items-center rounded-[4px] bg-[#FAF6E5] px-3 text-xs font-semibold uppercase text-black">
            {product.categories[0].name}
          </p>
        </div>
      )}
      {product.manufacturers && product.manufacturers.length > 0 && (
        <div className="flex w-fit flex-nowrap items-center justify-start gap-2">
          <Paragraph size="sm" className="whitespace-nowrap">
            {t('text175')}:
          </Paragraph>
          <p className="text-xs font-semibold uppercase text-black">
            {product.manufacturers[0].name}
          </p>
        </div>
      )}
      <div className="flex w-fit flex-nowrap items-center justify-start gap-2">
        <Paragraph size="sm" className="whitespace-nowrap">
          {t('text228')}:
        </Paragraph>
        <p className="text-xs font-semibold uppercase text-black">{product.code}</p>
      </div>
    </div>
  );
}
